









































































































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';
import AttributeButtons from './AttributeButtons.vue';
import DraggableIcon from './DraggableIcon.vue';
import { Action, State } from 'vuex-class';
import {
  CreateNewPrimaryOrgResponse,
  MasterGroupsResponseDTO
} from '@/store/modules/admin/types/group.types';
import { RootState } from '@/store/store';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import CreateNewOrganisationModal from '@/views/JTMS/Dashboard/CreateCourses/CourseLevelAttributes/components/CreateNewOrganisationModal.vue';
import { GroupLevelAttributeValue } from '@/jbi-shared/types/jaas-group-level-attributes.types';

@Component({
  components: {
    AttributeButtons,
    DraggableIcon
  }
})
export default class GroupLevelAttributeOrganisationField extends Vue {
  @Prop() attributeValue!: GroupLevelAttributeValue;
  @Prop() fieldClasses!: any;
  @Prop() duplicationError!: boolean;
  @Prop({ default: false }) isSettings!: boolean;
  @Prop({ default: false }) overrideDisableDraggable!: boolean;
  @Prop({ default: false }) overrideDisableAttributeButton!: boolean;
  @Prop() deleteAttribute!: () => void;
  @Prop() updateAttributeValue!: (attribute: GroupLevelAttributeValue) => void;
  @Prop() toggleAttributeRequire!: (
    attribute: GroupLevelAttributeValue
  ) => void;
  @Prop() editAttribute!: (attribute: GroupLevelAttributeValue) => void;

  fieldErrorMsg: string = '';
  selectedOrganisation: MasterGroupsResponseDTO | null = null;
  primaryOrganisations: MasterGroupsResponseDTO[] = [];
  searchTerm: string = '';
  // Local variable for triggering reassign on selected organisation
  primaryOrgCreationFromModal: CreateNewPrimaryOrgResponse | null = null;

  @Action('admin/getAllProtectedMasterGroups')
  getAllProtectedMasterGroups!: () => void;

  @State((state: RootState) => state.admin.masterGroups)
  masterGroups!: MasterGroupsResponseDTO[];

  @State(
    ({ admin }: RootState) => admin.apiState.getAllProtectedMasterGroups.success
  )
  getAllMasterGroupsSuccess!: boolean;

  mounted() {
    this.getAllProtectedMasterGroups();
  }

  // Computed property so changes from the value from parent component are synced
  get isRequired() {
    return this.attributeValue.groupLevelAttributeSpec.isRequired;
  }

  get filteredOrganisations() {
    return this.primaryOrganisations.filter(
      (org: MasterGroupsResponseDTO) =>
        org.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0
    );
  }

  openAddOrganisationModal(): void {
    this.$buefy.modal.open({
      parent: this,
      component: CreateNewOrganisationModal,
      hasModalCard: true,
      trapFocus: true,
      canCancel: false,
      events: {
        addNewPrimaryOrganisation: (response: CreateNewPrimaryOrgResponse) => {
          this.primaryOrgCreationFromModal = response;
          const {
            groupId,
            groupCreationSuccess
          } = this.primaryOrgCreationFromModal;
          if (groupCreationSuccess && groupId) {
            // Refetch to update the list of protected master groups
            this.getAllProtectedMasterGroups();
          }
        }
      }
    });
  }

  @Watch('attributeValue.value', { deep: true })
  validateRequiredFieldValues(): void {
    // validate null / empty values for required fields
    if (!this.attributeValue.value) {
      this.fieldErrorMsg = `${this.attributeValue.label} is required.`;
      this.attributeValue.hasFieldError = true;
      this.updateAttributeValue(this.attributeValue);
      return;
    }

    this.fieldErrorMsg = '';
    this.attributeValue.hasFieldError = false;
    this.updateAttributeValue(this.attributeValue);
  }

  @Watch('isRequired')
  updateErrorState() {
    if (this.isSettings) {
      this.validateRequiredFieldValues();
      return;
    }

    this.attributeValue.hasFieldError = true;
    this.updateAttributeValue(this.attributeValue);
  }

  @isTruthy
  @Watch('selectedOrganisation')
  assignPrimaryOrganisation() {
    this.attributeValue.value = this.selectedOrganisation!.name;
    this.returnParentGroup();
  }

  @isTruthy
  @Watch('getAllMasterGroupsSuccess')
  onGetAllMasterGroupsSuccess() {
    this.primaryOrganisations = this.masterGroups;

    // Assign selected organisation if in course settings
    if (this.isSettings && this.attributeValue.value) {
      this.selectedOrganisation = this.primaryOrganisations.find(
        (org: MasterGroupsResponseDTO) => org.name === this.attributeValue.value
      ) as MasterGroupsResponseDTO;
    }

    // Preselect newly createad primary org
    if (!!this.primaryOrgCreationFromModal) {
      this.selectedOrganisation = this.primaryOrganisations.find(
        (org: MasterGroupsResponseDTO) =>
          org.id === this.primaryOrgCreationFromModal?.groupId
      )!;
    }
  }

  /**
   * Separate event to pass selected group object to parent component.
   * Used for constructing course creation payload in `CourseLevelAttribute.vue`
   */
  @Emit('parent-group')
  returnParentGroup() {
    return this.selectedOrganisation;
  }
}
